import type { OwnerStatusId } from "@/types/common/ids";

import { cloneDeep } from "es-toolkit";

import { brandNumber } from "@/lib/branded";
import { branded } from "@/lib/helpers/branded-helper";
import { anemicReference } from "@/types/backoffice/dto/common/references";

export enum ESiteSubOwnerStatusType {
  OTHER = "OTHER",
  OWNER = "OWNER",
  TENANT = "TENANT",
  UNDEFINED = "UNDEFINED",
}

export interface ISiteSubOwnerStatusType {
  readonly id: OwnerStatusId;
  readonly description: ESiteSubOwnerStatusType;
}

export const siteSubOwnerStatusTypeSchema = anemicReference(branded.ownerStatusId);

export const SiteSubOwnerStatusTypes: Record<ESiteSubOwnerStatusType, ISiteSubOwnerStatusType> = {
  [ESiteSubOwnerStatusType.OWNER]: {
    id: brandNumber(2),
    description: ESiteSubOwnerStatusType.OWNER,
  },
  [ESiteSubOwnerStatusType.TENANT]: {
    id: brandNumber(3),
    description: ESiteSubOwnerStatusType.TENANT,
  },
  [ESiteSubOwnerStatusType.OTHER]: {
    id: brandNumber(1),
    description: ESiteSubOwnerStatusType.OTHER,
  },
  [ESiteSubOwnerStatusType.UNDEFINED]: {
    id: brandNumber(4),
    description: ESiteSubOwnerStatusType.UNDEFINED,
  },
};

export function getSiteSubOwnerStatusTypeById(id?: OwnerStatusId | null): ISiteSubOwnerStatusType | undefined {
  if (id === null || id === undefined) {
    return undefined;
  }

  return Object.values(SiteSubOwnerStatusTypes).find((o) => o.id === id);
}

export function getAllSiteSubOwnerStatusTypes(): Array<ISiteSubOwnerStatusType> {
  return cloneDeep(Object.values(SiteSubOwnerStatusTypes));
}
